import { Box, Select, TextField } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { SelectChangeEvent } from '@mui/material/Select';
import { useApiUrl } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useCallback, useEffect, useState } from "react";
import { dataProvider } from "rest-data-provider";

export const FollowersSettingsCreate = () => {
    const {
        saveButtonProps,
        refineCore: { formLoading },
        register,
        formState: { errors },
    } = useForm();

    // badgeName
    const apiUrl = useApiUrl();
    const [badgeId, setBadgeId] = useState<string>("");
    const [badgeNameArr, setBadgeNameArr] = useState<{value: string; type: string}[]>([]);
    const badgeNameDataFun = useCallback(() => {
        return  dataProvider(apiUrl)
        .getList({resource: "badge"})
        .then((res) => {
            if (res?.data && res?.data.length !== 0) {
                const arr = res.data.map((item: any) => {
                    return {
                        value: item?.id,
                        type: item?.name,
                    }
                });
                setBadgeNameArr(arr);
            }
            return res?.data;
        });
    }, [apiUrl]);
    const handleChange = (event: SelectChangeEvent) => {
        setBadgeId(event.target.value as string);
    }
    useEffect(() => {
        badgeNameDataFun();
    },[badgeNameDataFun]);

    const [gte, setGte] = useState("");
    return (
        <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
            <Box
                component="form"
                sx={{ display: "flex", flexDirection: "column" }}
                autoComplete="off"
            >
                <FormControl fullWidth style={{marginTop: "10px", marginBottom: "10px"}}>
                    <InputLabel id="badgesId">BadgeName</InputLabel>
                    <Select
                        {...register("badgeId", {
                        })}
                        labelId="badgesId"
                        value={badgeId}
                        label="BadgeName"
                        onChange={handleChange}
                    >
                        {
                        badgeNameArr.map((item) => {
                            return <MenuItem key={item.value} value={item.value}>{item.type}</MenuItem>
                        })
                    }
                    </Select>
                </FormControl>
                <TextField
                    {...register("gte", {
                        required: "This field is required",
                        validate: () => {
                            var intRegex = /^\d+$/; 
                            return intRegex.test(gte);
                        }
                    })}
                    error={!!(errors as any)?.gte}
                    helperText={"Gte is required and gte must be non-negative integer!"}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="Gte"
                    name="gte"
                    value={gte}
                    onChange={(e) => {
                        setGte(e.target.value);
                    }}
                />
                <TextField
                    {...register("name", {
                        required: "This field is required",
                    })}
                    error={!!(errors as any)?.name}
                    helperText={(errors as any)?.name?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="Name"
                    name="name"
                />
                <TextField
                    {...register("description", {
                        required: "This field is required",
                    })}
                    error={!!(errors as any)?.description}
                    helperText={(errors as any)?.description?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="Description"
                    name="description"
                />
            </Box>
        </Create>
    );
};